export const iconFontAwesomeAccessibilityWheelchair = (
	<i className="fa-solid fa-wheelchair"></i>
);
